import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import ContactSection from './components/ContactSection';
import Breadcrumb from '@/components/feature/Breadcrumb';

const aboutPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于红桃影院',
  description: '红桃影院成立于2020年，是一家专注于在线影视内容分发的高科技互联网平台，为全球华语用户提供海量高清电影、电视剧、动漫、综艺免费观看服务。',
  url: 'https://www.hongtao.tv/about',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '红桃影院',
  url: 'https://www.hongtao.tv/',
  description: '红桃影院是您的首选在线影视平台，提供海量高清电影、电视剧、动漫等内容免费观看。',
  email: 'contact@hongtao.tv',
  address: {
    '@type': 'PostalAddress',
    addressLocality: '深圳',
    addressRegion: '广东',
    addressCountry: 'CN',
    streetAddress: '南山区科技园南路88号',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'contact@hongtao.tv',
    availableLanguage: ['Chinese'],
    hoursAvailable: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        opens: '09:00',
        closes: '22:00',
      },
    ],
  },
};

export default function AboutPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <title>关于红桃影院 - 品牌介绍 | 联系方式 | 用户口碑</title>
      <meta name="description" content="红桃影院品牌介绍，了解红桃影院的使命愿景、用户口碑评价。如有任何问题欢迎通过联系表单或邮箱contact@hongtao.tv联系我们，我们将竭诚为您服务。" />
      <meta name="keywords" content="红桃影院,红桃影院官网,红桃影院联系方式,红桃影院品牌介绍,红桃影院口碑" />
      <link rel="canonical" href="https://www.hongtao.tv/about" />

      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/60">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={[
              { label: '首页', to: '/' },
              { label: '关于我们' },
            ]} />
          </div>
        </div>

        <BrandIntro />
        <Reputation />
        <ContactSection />
      </main>
    </>
  );
}